import type { CalendarTaskPriority } from "./types";

export const PRIORITY_COLOR_CLASS: Record<CalendarTaskPriority, string> = {
  low: "content-action-info",
  normal: "content-action-neutral",
  high: "content-action-notice",
  critical: "content-action-negative",
};

export const PRIORITY_BG: Record<CalendarTaskPriority, string> = {
  low: "background-info-subtle",
  normal: "background-neutral-subtle",
  high: "background-notice-subtle",
  critical: "background-negative-subtle",
};
